export enum ContentEditSegment {
    Unsubscribed = 'unsubscribed',
    SubscribedUser = 'subscribed_user',
    UpgradableUser = 'upgradable_user',
    EnterpriseNoPermission = 'enterprise_no_permission',
    Disabled = 'disabled',
}
